import { render, staticRenderFns } from "./DateInputEvento.vue?vue&type=template&id=5fa922cc&scoped=true"
import script from "./DateInputEvento.vue?vue&type=script&lang=js"
export * from "./DateInputEvento.vue?vue&type=script&lang=js"
import style0 from "./DateInputEvento.vue?vue&type=style&index=0&id=5fa922cc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa922cc",
  null
  
)

export default component.exports